import Model from 'flarum/common/Model';
/**
 * A reader's report about an article. Only editors ever load these: the API
 * returns an empty set to anybody else.
 */
export default class WikiReport extends Model {
  reason = (() => Model.attribute('reason'))();
  detail = (() => Model.attribute('detail'))();
  isResolved = (() => Model.attribute('isResolved'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  resolvedAt = (() => Model.attribute('resolvedAt', Model.transformDate))();
  user = (() => Model.hasOne('user'))();
  resolvedBy = (() => Model.hasOne('resolvedBy'))();
  article = (() => Model.hasOne('article'))();
}
flarum.reg.add('linkrobins-wiki', 'common/models/WikiReport', WikiReport);